import React from "react";
import phone from "../images/phone.png";
import { useEffect } from "react";
// importing aos
import AOS from "aos";
import "aos/dist/aos.css";
function MobileAppSection() {
  useEffect(() => {
    AOS.init({
      once: true,
    });
  }, []);
  return (
    <section id="collection-pets">
      <div className="wrapper">
        {/* Hippie app */}
        <div className="mobile-app">
          <div className="col-left" data-aos="zoom-in" data-aos-delay="300">
            <img src={phone} alt="" />
          </div>
          <div className="col-right">
            <h2>The Heal App</h2>
            {/* <span>Coming Post-Mint</span> */}
            <p>
            A cutting-edge nexus of wellness and technology. By gamifying the wellness journey and creating a lively, supportive community, we're turning sedentary lifestyles around and making health and wellness accessible, enjoyable, and rewarding. We've crafted an innovative platform that blends AI technology with web3 rewards, creating a truly unique wellness experience.
            </p>
            <p>
              Engage with your friends and rank up the leaderboard. Access your
              favorite recipes, speak to a life coach, look through the
              workouts, practice breathwork, meditate, and more. There’s
              something for everyone no matter where you are on your wellness
              journey.
            </p>
            <p>
              While this app is unlocked for our holders, it will also be
              available through the App Store and Google Play through a monthly
              subscription model.
            </p>
            <div className="app-links">
              {/* <a href="/">
                <img src={google} alt="google" />
              </a>
              <a href="/">
                <img src={apple} alt="apple" />
              </a> */}
              <a href="https://thehealapp.io/" target="_blank">THE HEAL APP</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MobileAppSection;
